module.exports = __webpack_public_path__ + "img/coupon.1eadf8a4.svg";